// extracted by mini-css-extract-plugin
module.exports = {"modal-header":"modal-header-2b-_IdI","x-icon":"x-icon-1SQw7Hc"};